import React, { useEffect, useState } from "react";
import { Route, Link, Routes } from "react-router-dom";
import "./App.css";

import axios from "axios";

import Sample from "./multiPage/Sample";
import Stats from "./multiPage/Stats";
import CrossTab from "./multiPage/CrossTab";
import Correlation from "./multiPage/Correlation";
import Faq from "./multiPage/Faq";
import Landing from "./chartPage/layout/Landing";

import { Loading } from "./loaders";
import LogReport from "./logReport";

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

function App() {
  const current_page =
    window.location.href.split("/")[
    Object.keys(window.location.href.split("/")).length - 1
    ];

  const [hasCritical, setHasCritical] = useState(false);
  const [hasWarning, setHasWarning] = useState(false);
  const [logData, setLogData] = useState(null);

  const [data, setData] = useState(null);
  const [btnSelector, setBtnSelector] = useState(current_page);
  const [logRatioIndex, setLogRatioIndex] = useState(null);

  useEffect(() => {
    new Promise(function acquireId(res) {
      const logId = document.getElementById("log-id").value;
      if (!logId) {
        setTimeout(() => acquireId(res), 1000);
        return;
      }
      setLogRatioIndex(logId);
      res(logId);
    })
      .then(
        (logId) =>
          new Promise(async function obtainWebLog(res) {
            const resp = await api.get(
              `https://logratio.com/wp-content/themes/logratio/includes/lr_form_download.php?action=get_web_log&log_id=${logId}`
            );

            if (resp.status !== 200 || !resp.data?.length) {
              setTimeout(() => obtainWebLog(res), 1000);
              return;
            }

            let criticalPresent = false;
            resp.data.forEach((item) => {
              if (item.kind.toLowerCase() === "warning") {
                item.order = 2;
                setHasWarning(true);
              } else if (item.kind.toLowerCase() === "error") {
                item.order = 1;
                criticalPresent = true;
                setHasCritical(true);
              } else item.order = 3;
            });

            setLogData(resp.data.sort((a, b) => a.order - b.order));
            res({ logId, criticalPresent });
          })
      )
      .then(
        ({ logId, criticalPresent }) =>
          new Promise(async function obtainJSONReport(res) {
            if (criticalPresent) {
              res();
              return;
            }

            const resp = await fetch(
              `https://logratio.com/wp-content/themes/logratio/includes/lr_form_download.php?action=get_json_report&log_id=${logId}`
            );

            const data = await resp.json()

            if (!resp.ok || !data.main_db) {
              setTimeout(() => obtainJSONReport(res), 1000);
              return;
            }
            setData(data);
          })
      );
  }, []);

  if (data) {
    return (
      <div>
        <div
          className="header-container"
          style={{
            paddingBottom: "15px",
            borderBottom: "1px solid rgba(0,0,0,.1)",
          }}
        >
          <div className="col-9 d-flex justify-content-center">
            <span>
              <Link
                to="/"
                className={
                  btnSelector === "faq" || btnSelector === ""
                    ? "header_btn_selected"
                    : "header_btn"
                }
                onClick={(e) => setBtnSelector("")}
              >
                FAQ
              </Link>
            </span>
            <span>
              <Link
                to="/testing"
                className={
                  btnSelector === "tests" ? "header_btn_selected" : "header_btn"
                }
                onClick={(e) => setBtnSelector("tests")}
              >
                Tests
              </Link>
            </span>
            <span>
              <Link
                to="/sample"
                className={
                  btnSelector === "sample"
                    ? "header_btn_selected"
                    : "header_btn"
                }
                onClick={(e) => setBtnSelector("sample")}
              >
                Sample
              </Link>
            </span>
            <span>
              <Link
                to="/stats"
                className={
                  btnSelector === "stats" ? "header_btn_selected" : "header_btn"
                }
                onClick={(e) => setBtnSelector("stats")}
              >
                Stats
              </Link>
            </span>
            <span>
              <Link
                to="/correlation"
                className={
                  btnSelector === "correlation"
                    ? "header_btn_selected"
                    : "header_btn"
                }
                onClick={(e) => setBtnSelector("correlation")}
              >
                Correlations
              </Link>
            </span>
            <span>
              <Link
                to="/crossTab"
                className={
                  btnSelector === "crossTab"
                    ? "header_btn_selected"
                    : "header_btn"
                }
                onClick={(e) => setBtnSelector("crossTab")}
              >
                CrossTabs
              </Link>
            </span>
            <span>
              <Link
                to="/chart"
                className={
                  btnSelector === "chart" ? "header_btn_selected" : "header_btn"
                }
                onClick={(e) => setBtnSelector("chart")}
              >
                Charts
              </Link>
            </span>
          </div>
          <div className="col-3">
            <span className="download-container">
              <div className="dropdown">
                <button className="dropbtn">
                  Reports
                  <i className="fa fa-caret-down ml-2"></i>
                </button>
                <div className="dropdown-content">
                  <a
                    href={
                      "https://logratio.com/wp-content/themes/logratio/includes/lr_form_download.php?action=get_xlsx_report&log_id=" +
                      logRatioIndex
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    Excel report (numbers)
                  </a>
                  <a
                    href={
                      "https://logratio.com/wp-content/themes/logratio/includes/lr_form_download.php?action=get_pdf_report&log_id=" +
                      logRatioIndex
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    PDF report (interpretation)
                  </a>
                </div>
              </div>
            </span>
          </div>
        </div>

        <Routes>
          <Route path="/" exact element={<Faq data={data} />} />
          <Route path="/sample" exact element={<Sample data={data} />} />
          <Route path="/stats" element={<Stats data={data} />} />
          <Route path="/correlation" element={<Correlation data={data} />} />
          <Route path="/crossTab" element={<CrossTab data={data} />} />
          <Route path="/chart" element={<Landing data={data} />} />
          <Route
            path="/testing"
            element={<LogReport logData={logData} hasCritical={hasCritical} />}
          />
        </Routes>
      </div>
    );
  } else if (logData) {
    return (
      <Routes>
        <Route
          path="/"
          element={<LogReport logData={logData} hasCritical={hasCritical} />}
        />
      </Routes>
    );
  }
  return (
    <div>
      <Loading />
    </div>
  );
}

export default App;
